import { render, staticRenderFns } from "./senaraiSelesai.vue?vue&type=template&id=61a3b837&scoped=true&"
import script from "./senaraiSelesai.vue?vue&type=script&lang=js&"
export * from "./senaraiSelesai.vue?vue&type=script&lang=js&"
import style0 from "./senaraiSelesai.vue?vue&type=style&index=0&id=61a3b837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3b837",
  null
  
)

export default component.exports